import { gql, useMutation } from '@apollo/client';

import { Server } from '../../apollo/types';

interface SessionIntention {
  shortId: string;
  appointmentShortId: string;
  clientUserShortId: string;
  providerShortId: string;
  contentText: string;
  contentImageUrl: string | null;
  notificationCadence: string | null;
  notificationTimeOfDay: string | null;
  expiredAt: string | null;
}

interface CreateSessionIntentionData {
  createSessionIntention: {
    sessionIntention: SessionIntention;
  };
}

interface CreateSessionIntentionVariables {
  clientUserShortId: string;
  appointmentShortId: string;
  contentText: string;
}

const createSessionIntentionDocument = gql`
  mutation CreateSessionIntention($clientUserShortId: String!, $appointmentShortId: String!, $contentText: String!) {
    createSessionIntention(
      clientUserShortId: $clientUserShortId
      appointmentShortId: $appointmentShortId
      contentText: $contentText
    ) {
      sessionIntention {
        shortId
        appointmentShortId
        clientUserShortId
        providerShortId
        contentText
        contentImageUrl
        notificationCadence
        notificationTimeOfDay
        expiredAt
      }
    }
  }
`;

export function useCreateSessionIntentionMutation() {
  return useMutation<CreateSessionIntentionData, CreateSessionIntentionVariables>(createSessionIntentionDocument, {
    context: {
      server: Server.MONOLITH,
    },
  });
}
